module.exports = __webpack_public_path__ + "img/Ptuapp10.74c9d419.png";